export default __webpack_public_path__ + "static/media/earth-2.55643d99.jpg";